import React from 'react';
import NikeVanLogo from './NikeVanLogo';
import SkuBar from './SkuBar';

function ProductBarcodeHeader({logoProps, skuBarProps}) {
    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5mm', marginTop: '2mm'}}>
            <div style={{height: '3mm'}}><NikeVanLogo {...logoProps} /></div>
            <div style={{height: '3mm'}}><SkuBar {...skuBarProps} /></div>
        </div>
    );
}

export default ProductBarcodeHeader;